const md = `# Running a Workflow

Click **Run** on any workflow in the library.  A modal pops up with
three things you can tweak.

## 1. Variables

Each workflow declares its own variables (e.g. *Item Description*,
*Quantity*, *Unit Price*, *Department*, *Cost Center*).  Defaults are
sensible — change them when you want the demo to *feel* like a real
customer scenario instead of generic placeholder data.

## 2. Pacing

* **Fast** — 0.5× delay multipliers.  Use this when you just need to
  produce an asset or confirm a workflow still works.  Total runtime
  ~60–90 s.
* **Normal** — the workflow's authored pacing.
* **Presentation** — 1.5× delay multipliers + a synthetic dwell after
  each click.  Use this when you intend to *show* the MP4 to a human.
  Total runtime ~2.5–4 min.

## 3. Show cursor

Renders a synthetic mouse cursor in the screen recording.  Costs about
2% of CPU; turn it off only if you're producing a programmatic clip
that someone else will narrate over.

## 4. Auto-generate narration & MP4

When ticked (default), three background jobs are scheduled the moment
the Playwright session ends:

1. **Narration** — GPT-5.2 reads the step log + screenshots and writes
   a 200–500 word script.  Persona-aware (see Personas).
2. **Voiceover** — ElevenLabs *Lily* (default) speaks the script into a
   high-quality MP3.
3. **Final MP4** — ffmpeg muxes the Playwright \`.webm\` with the
   voiceover audio.  Visible on the run-detail page when ready.

Untick the box if you want to write the narration yourself; you can
always trigger the pipeline manually from the run-detail page later.

## What happens after you click Run?

You're redirected to the run-detail page.  The progress bar advances
as steps complete.  Each finished step's screenshot appears in the
gallery below the bar.  When the run finishes, the narration panel
fills in, then the voiceover panel, then the final video.  Nothing
needs your input — you can close the tab and come back later.
`;

export default md;
